import { AlertDialog, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "../../ui/alert-dialog.tsx"
import { Loader2 } from "lucide-react"
import { AlertDialogAction, AlertDialogCancel } from "../../ui/alert-dialog.tsx"
import { useDeleteSubAccount } from "../../../hooks/useSubAccounts.ts"
import { toast } from "sonner"

function DeleteDialog({ user_id, email, setIsOpen, isOpen }: { user_id: string, email: string, setIsOpen: (open: boolean) => void, isOpen: boolean }) {
  const deleteSubAccountMutation = useDeleteSubAccount();
  
  const removeAccount = async () => {
    try {
      await deleteSubAccountMutation.mutateAsync(user_id);
      toast.success(`Account ${email} deleted successfully`);
      setIsOpen(false); // Close dropdown after deletion
    } catch (error) {
      console.error('Failed to delete account:', error);
      toast.error(`Failed to delete account: ${error instanceof Error ? error.message : 'Unknown error'}`);
    }
  };
  return (
    <AlertDialog open={isOpen} onOpenChange={setIsOpen}>

      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete Sub-Account</AlertDialogTitle>
          <AlertDialogDescription>
            Are you sure you want to delete the account for <strong>{email}</strong>? 
            This action cannot be undone and will permanently remove all user data.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={() => setIsOpen(false)}>Cancel</AlertDialogCancel>
          <AlertDialogAction 
            onClick={removeAccount}
            className="bg-red-600 hover:bg-red-700 text-white"
            disabled={deleteSubAccountMutation.isPending}
          >
            {deleteSubAccountMutation.isPending ? (
              <><Loader2 className="h-4 w-4 mr-2 animate-spin" />Deleting...</>
            ) : (
              'Delete Account'
            )}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}

export default DeleteDialog